import { useState } from "react";
import { Col, Card, Row } from "react-bootstrap";
import classes from "./createOrderApplication.module.scss";
import Select from "react-select";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const CreateAppOrderSignatures = ({ _params, data, setData }) => {
	const [activeSignatures, setActiveSignatures] = useState(false);

	const handleSignatorieChange = (idx, value) => {
		setData((prevData) => {
			const sigList = [...prevData.signatures];
			sigList[idx] = { ...sigList[idx], ...(value ? { user_id: value } : { user_id: "" }) };
			return {
				...prevData,
				signatures: sigList,
			};
		});
	};

	return (
		<Col md={12} className={classes.col_base}>
			<Card className={activeSignatures && "active"}>
				<Card.Header onClick={() => setActiveSignatures(!activeSignatures)} className={activeSignatures && "active"}>
					Firmas
					<div>
						<span>
							<strong> Cant. de Firmas:</strong> {data.signatures.length ? data.signatures.length : 0}
						</span>
					</div>
				</Card.Header>

				{activeSignatures && (
					<>
						<Card.Body>
							<Row>
								{data.signatures?.map((sig, idx) => {
									return (
										<Col md={4} key={idx} className={classes.divInput}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>{sig.name}</div>
												<Select
													isClearable
													placeholder={<div></div>}
													value={sig.users.filter((s) => s.value === sig.user_id)[0]}
													options={sig.users}
													onChange={(e) => handleSignatorieChange(idx, e?.value)}
													menuPortalTarget={document.body}
													menuPlacement="top"
													components={{
														NoOptionsMessage,
													}}
												/>
											</div>
										</Col>
									);
								})}
							</Row>
						</Card.Body>
					</>
				)}
			</Card>
		</Col>
	);
};

export default CreateAppOrderSignatures;
